import xss from 'xss';

const commonAllowedAttributes = ['class', 'id'];

const htmlSanitizerOptions = {
    whiteList: {
        a: ['href', 'class', 'target', 'rel', 'id'],
        b: commonAllowedAttributes,
        i: commonAllowedAttributes,
        em: commonAllowedAttributes,
        strong: commonAllowedAttributes,
        p: commonAllowedAttributes,
        br: [],
        ul: commonAllowedAttributes,
        ol: commonAllowedAttributes,
        li: commonAllowedAttributes,
        span: commonAllowedAttributes,
        div: commonAllowedAttributes,
        h1: commonAllowedAttributes,
        h2: commonAllowedAttributes,
        h3: commonAllowedAttributes,
        h4: commonAllowedAttributes,
        h5: commonAllowedAttributes,
        h6: commonAllowedAttributes,
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    allowCommentTag: false,
};

/**
 * ASVS V1.2.1: Output encoding for HTML content
 * Sanitizes untrusted HTML to prevent XSS attacks
 *
 * @param dirtyHtml - Raw HTML from external sources
 * @returns Sanitized HTML safe for rendering
 */
export function sanitizeHtml(dirtyHtml: string): string {
    if (!dirtyHtml || typeof dirtyHtml !== 'string') {
        return '';
    }

    return xss(dirtyHtml, htmlSanitizerOptions);
}
